<template>
<div>
    <v-app>
        <v-container class="fill-height pa-0 ">
            <v-row class="no-gutters elevation-4">
                <v-col cols="auto" class="flex-grow-1 flex-shrink-0">
                    <v-responsive v-if="activeChat" class="overflow-y-hidden fill-height" height="450">
                        <v-card flat class="d-flex flex-column fill-height">
                            <v-card-title style="font-weight:bold;font-size:15px;"> {{ receiver.name }} ({{ receiver.mobiles[0]}}) </v-card-title>
                            <v-card-text class="flex-grow-1 overflow-y-auto" v-chat-scroll>
                                <template v-for="(msg, i) in messages">
                                    <div :class="{ 'd-flex flex-row-reverse': msg.me }">
                                        <v-menu offset-y>
                                            <template v-slot:activator="{ on }">
                                                <v-hover v-slot:default="{ hover }">
                                                    <v-chip :color="msg.me ? '#03A9F4' : ''" dark style="height:auto;white-space: normal;" class="pa-4 mb-2" v-on="on">              
                                                       <div v-if="msg.type == 'media'">
                                                        <img :src="msg.content" :width="250" :height="250" />
                                                       </div>
                                                        <div v-else-if="msg.me">
                                                      
                                                       {{ msg.content }}
                                                       </div>
                                                       <div v-else>
                                                         {{ msg.content }}
                                                        </div>
                                                        <sub class="ml-2" style="font-size: 11px">{{ msg.created_at }}</sub>
                                                    </v-chip>
                                                </v-hover>
                                            </template>
                                        </v-menu>
                                    </div>
                                </template>
                            </v-card-text>
                           
                   <v-card-text class="flex-shrink-1">
                         
                                <v-text-field  @keydown.enter="sendMessage" class="text-green" v-model="message" placeholder="type a message" type="text"  outlined hide-details v-bind:style="{ width: ['200%'] }" />
                          
                            <v-btn
                                      
                                        class="ma-1 float-right octopus-btn-default alert alert-danger"
                                        color="#03A9F4"
                                        dark
                                        @click="sendMessage"
                                    >
                                        send
                                        <v-icon
                                        color="#03A9F4"
                                        right
                                        v-bind:style="{ left: ['10px'] }"
                                        >

                                        </v-icon>
                                </v-btn>

                            
                            </v-card-text>
                        </v-card>
                    </v-responsive>
                        <v-container v-else>
                        {{ errorMessage }}
                        </v-container>
                </v-col>
            </v-row>
        </v-container>
   
    </v-app>
</div>
</template>
<script>


import { mapGetters } from 'vuex'
export default {
    name:'Whatsapp',
    props:["receiver_id"],
    data: () => ({
        message: "",
        messageForm: {
            content: "",
            me: true,
            created_at: "11:11am"
        }
    }),
    methods : {
        sendMessage: function() {
            if(this.message.trim() == "") {
                return;
            }
            const formData = new FormData();
            formData.append('body', this.message);
            formData.append('messageType', "text");
            formData.append('from', "+14155238886");
            formData.append('to', this.receiver.mobiles[0]);
            formData.append('receiverId',this.receiver_id);
            this.$store.dispatch('Whatsapp/postMessage',formData)
            this.message = "";
        },
        getMessage: function() {
            const formData = new FormData();
            formData.append('receiverId', this.receiver_id);
            this.$store.dispatch("Whatsapp/getMessages",formData);
        }
    },
    mounted(){
        this.getMessage();
    },
    computed: {
        ...mapGetters({
            messages: 'Whatsapp/getMessages',
            receiver: 'Whatsapp/getReceiver',
            activeChat: 'Whatsapp/getActiveChat',
            errorMessage: 'Whatsapp/getErrorMessage',
        }),
    }
}
</script>



<style scoped>
    ::v-deep .v-application--wrap {
        min-height: fit-content;
        min-width: fit-content;
        width: 100%;
        
    }
     ::v-deep .v-responsive__content {
        width: 100%;
        
        min-width: fit-content;

}
::v-deep .text-field {
  width: 50%;
  padding: 12px 0px;
  margin: 8px 0;
  display: inline-block;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
}

::v-deep .text-green input {
   margin: 5px 5px 5px 0px;
   padding: 1px 10px 10px 0px;
      width:100%;
    }

::v-deep .v-input__control{
    width:200%;
}

    
</style>
<style scoped>

    ::v-deep  .v-text-field input:focus{
    outline: none;
    }
        ::v-deep  .v-text-field input{
             margin: 5px 0px 5px 0px;
            padding: 15px 10px 10px 15px;
      
            color: black;
            
            border: 1px solid gray;
            border-radius: 10px;

        }
        ::v-deep  fieldset{
            display:none;
            
        }
        ::v-deep i{
            display:none;
        }
    
</style>
<style scoped src="vuetify/dist/vuetify.min.css"></style>
